const getRelativeDate = (days) => {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toISOString().split('T')[0];
};

const dummyVouchers = [
{
  "guest_information": {
    "guest_name": "Bhavin Shah",
    "contact_number": "9167132037",
    "total_guests_adults": 6,
    "total_guests_children": 0
  },
  "tour_info": {
    "start_date": "2026-03-18",
    "end_date": "2026-03-29",
    "destinations": [
      {
        "city": "Jibhi",
        "location_id": null,
        "location_name": "Jibhi",
        "journey_date": "2026-03-18",
        "_id": "69d7da95ca72c980c3523a72"
      },
      {
        "city": "Kasol",
        "location_id": null,
        "location_name": "Kasol",
        "journey_date": "2026-03-20",
        "_id": "69d7da95ca72c980c3523a73"
      },
      {
        "city": "Manali",
        "location_id": null,
        "location_name": "Manali",
        "journey_date": "2026-03-21",
        "_id": "69d7da95ca72c980c3523a74"
      },
      {
        "city": "Hamta",
        "location_id": null,
        "location_name": "Hamta",
        "journey_date": "2026-03-23",
        "_id": "69d7da95ca72c980c3523a75"
      },
      {
        "city": "Dharamshala",
        "location_id": null,
        "location_name": "Dharamshala",
        "journey_date": "2026-03-24",
        "_id": "69d7da95ca72c980c3523a76"
      },
      {
        "city": "Dalhousie",
        "location_id": null,
        "location_name": "Dalhousie",
        "journey_date": "2026-03-26",
        "_id": "69d7da95ca72c980c3523a77"
      },
      {
        "city": "Amritsar",
        "location_id": null,
        "location_name": "Amritsar",
        "journey_date": "2026-03-28",
        "_id": "69d7da95ca72c980c3523a78"
      }
    ]
  },
  "location_sharing": {
    "enabled": false,
    "share_token": "TRACK-WKZN-8G3N"
  },
  "_id": "69d7da9507ea6c1e947ecac4",
  "booking_id": "bwkzn",
  "__v": 0,
  "agent_id": "69d78d87feb5868784a5b675",
  "contact_details": [],
  "createdAt": "2026-04-09T16:57:57.801Z",
  "hotel_bookings": [
    {
      "hotel_name": "Cottages (Jibhi)",
      "hotel_address": "Jibhi, Himachal Pradesh",
      "check_in_date": "2026-03-18",
      "check_out_date": "2026-03-20",
      "no_of_nights": 2,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "Breakfast & Dinner",
      "confirmation_number": null,
      "room_category": "Standard",
      "city": "Jibhi",
      "_id": "69d7da95ca72c980c3523a7c"
    },
    {
      "hotel_name": "Hotel Royal Kasol",
      "hotel_address": "Kasol, Himachal Pradesh",
      "check_in_date": "2026-03-20",
      "check_out_date": "2026-03-21",
      "no_of_nights": 1,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "MAPAI (Breakfast + Dinner)",
      "confirmation_number": "89we8",
      "room_category": "Premium Room with a Mountain view",
      "city": "Kasol",
      "_id": "69d7da95ca72c980c3523a7d"
    },
    {
      "hotel_name": "Echor Himalayan Heights Luxe Resort & Spa",
      "hotel_address": "Manali, Himachal Pradesh",
      "check_in_date": "2026-03-21",
      "check_out_date": "2026-03-23",
      "no_of_nights": 2,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "MAP",
      "confirmation_number": "898e9w",
      "room_category": "Standard",
      "city": "Manali",
      "_id": "69d7da95ca72c980c3523a7e"
    },
    {
      "hotel_name": "Hobbit Hamta",
      "hotel_address": "Hamta, Himachal Pradesh",
      "check_in_date": "2026-03-23",
      "check_out_date": "2026-03-24",
      "no_of_nights": 1,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "Breakfast & Dinner",
      "confirmation_number": "9898",
      "room_category": "2 Geo Dome + 1 hobbit house",
      "city": "Hamta",
      "_id": "69d7da95ca72c980c3523a7f"
    },
    {
      "hotel_name": "DLS Meghavan Resort",
      "hotel_address": "Bhagsunag Rd, near Macleodganj Upper, Dharamshala, Himachal Pradesh 176219",
      "check_in_date": "2026-03-24",
      "check_out_date": "2026-03-26",
      "no_of_nights": 2,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "MAP",
      "confirmation_number": "MR7334",
      "room_category": "Premium Room With View MAP",
      "city": "Dharamshala",
      "_id": "69d7da95ca72c980c3523a80"
    },
    {
      "hotel_name": "Claret Inn",
      "hotel_address": "khasra no 804/724/4 khatoni no 141/157 mohal malunda, pargana bathri, Dalhousie, Himachal Pradesh 176306",
      "check_in_date": "2026-03-26",
      "check_out_date": "2026-03-28",
      "no_of_nights": 2,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "Breakfast and Dinner",
      "confirmation_number": "373",
      "room_category": "Premium room with balcony",
      "city": "Dalhousie",
      "_id": "69d7da95ca72c980c3523a81"
    },
    {
      "hotel_name": "Luxe Stayz Saffron",
      "hotel_address": "Plot No 13 O/S GHEE MANDI Amritsar - 110011 Punjab, India",
      "check_in_date": "2026-03-28",
      "check_out_date": "2026-03-29",
      "no_of_nights": 1,
      "total_guests": "6",
      "no_of_rooms": 3,
      "meal_plan": "MAP",
      "confirmation_number": "G 0210170",
      "room_category": "Deluxe",
      "city": "Amritsar",
      "_id": "69d7da95ca72c980c3523a82"
    }
  ],
  "important_notes": [
    "Carry a valid photo ID (Aadhaar/Passport) at all times during the trip.",
    "Personal expenses, tips & beverages are not included in the package.",
    "Arrive at airport/station at least 2 hrs (domestic) or 3 hrs (international) before departure."
  ],
  "is_deleted": false,
  "is_downloaded": false,
  "itenary_link": "http://localhost:8000/uploads/b542368853691fc8afabb2af905c3eb2",
  "itinerary": [
    {
      "day": "Day 1",
      "date": "18th March 2026",
      "remarks": [
        "Arrive in Jibhi and check into your cottages for a relaxing 2-night stay.",
        "Enjoy a delicious dinner at the property as part of your included meal plan.",
        "Spend your first evening soaking in the serene atmosphere of the Jibhi region."
      ],
      "_id": "69d7da95ca72c980c3523a66"
    },
    {
      "day": "Day 2",
      "date": "19th March 2026",
      "remarks": [
        "Start your day with a hearty breakfast at the cottage before heading out to explore.",
        "Discover hidden waterfalls or take a nature walk through the lush pine forests.",
        "Return to the property for a comfortable overnight stay and included dinner."
      ],
      "_id": "69d7da95ca72c980c3523a67"
    },
    {
      "day": "Day 3",
      "date": "20th March 2026",
      "remarks": [
        "Check out from Jibhi and travel to the vibrant town of Kasol for your next stay.",
        "Check into Hotel Royal Kasol into a room with a stunning mountain view.",
        "Experience the unique vibe of Kasol and enjoy your included dinner at the hotel."
      ],
      "_id": "69d7da95ca72c980c3523a68"
    },
    {
      "day": "Day 4",
      "date": "21st March 2026",
      "remarks": [
        "Depart from Kasol and make your way towards the popular hill station of Manali.",
        "Check into Echor Himalayan Heights Luxe Resort & Spa for a 2-night stay.",
        "Explore the Manali Mall Road or relax at the resort for the rest of the evening."
      ],
      "_id": "69d7da95ca72c980c3523a69"
    },
    {
      "day": "Day 5",
      "date": "22nd March 2026",
      "remarks": [
        "Enjoy a full day in Manali visiting landmarks like the Hadimba Devi Temple.",
        "Take in breathtaking views of the snow-capped peaks and the gushing Beas River.",
        "Return to your resort for an included dinner and a peaceful night's rest."
      ],
      "_id": "69d7da95ca72c980c3523a6a"
    },
    {
      "day": "Day 6",
      "date": "23rd March 2026",
      "remarks": [
        "Leave Manali for the Hobbit Hamta property for a specialized glamping experience.",
        "Settle into your allocated Geo Dome or hobbit house for a night under the stars.",
        "Enjoy a cozy evening with dinner surrounded by high-altitude natural beauty."
      ],
      "_id": "69d7da95ca72c980c3523a6b"
    },
    {
      "day": "Day 7",
      "date": "24th March 2026",
      "remarks": [
        "Transition from Hamta to the spiritual and scenic town of Dharamshala (McLeodganj).",
        "Check into DLS Meghavan Resort for two nights with premium mountain views.",
        "Visit the Dalai Lama Temple Complex or wander through the vibrant Tibetan market."
      ],
      "_id": "69d7da95ca72c980c3523a6c"
    },
    {
      "day": "Day 8",
      "date": "25th March 2026",
      "remarks": [
        "Explore upper Dharamshala and trek to the refreshing Bhagsunag Waterfall.",
        "Learn about Tibetan culture at local monasteries and the Norbulingka Institute.",
        "Enjoy your second evening at the resort with a scenic view and warm dinner."
      ],
      "_id": "69d7da95ca72c980c3523a6d"
    },
    {
      "day": "Day 9",
      "date": "26th March 2026",
      "remarks": [
        "Proceed from Dharamshala to the colonial-era hill station of Dalhousie for two nights.",
        "Check into Claret Inn and occupy a premium room featuring a private balcony.",
        "Spend a quiet evening taking a stroll through the pine-scented paths of Dalhousie."
      ],
      "_id": "69d7da95ca72c980c3523a6e"
    },
    {
      "day": "Day 10",
      "date": "27th March 2026",
      "remarks": [
        "Visit Khajjiar, known as 'Mini Switzerland,' a short scenic drive from Dalhousie.",
        "Walk around the expansive green meadows and dense cedar forests of the region.",
        "Return to Dalhousie for your final night in the hills with an included dinner."
      ],
      "_id": "69d7da95ca72c980c3523a6f"
    },
    {
      "day": "Day 11",
      "date": "28th March 2026",
      "remarks": [
        "Depart the mountains and travel to the historic city of Amritsar in Punjab.",
        "Check into Luxe Stayz Saffron, located conveniently near city attractions.",
        "Visit the magnificent Golden Temple in the evening for a spiritual experience."
      ],
      "_id": "69d7da95ca72c980c3523a70"
    },
    {
      "day": "Day 12",
      "date": "29th March 2026",
      "remarks": [
        "Have your final breakfast of the tour before checking out of your Amritsar hotel.",
        "Visit Jallianwala Bagh or the Wagah Border if your travel schedule permits.",
        "Conclude your memorable journey as you head for your onward departure."
      ],
      "_id": "69d7da95ca72c980c3523a71"
    }
  ],
  "status": "completed",
  "travel_bookings": [
    {
      "from": "Borivali",
      "to": "Mathura",
      "journey_date": "2026-04-10",
      "mode_of_transport": "train",
      "pnr": "121212",
      "seat_no": "24, 52",
      "operator": "Indian Railway",
      "vehicle_number": "1221212",
      "passenger_name": "Mohit",
      "departure_time": "12:05",
      "arrival_time": "12:55",
      "_id": "69d7da95ca72c980c3523a79"
    },
    {
      "from": "Nagpur",
      "to": "H Nizamuddin",
      "journey_date": "2026-04-11",
      "mode_of_transport": "flight",
      "pnr": null,
      "seat_no": null,
      "operator": "Indian Railways",
      "vehicle_number": "12721 (Dakshin SF Exp)",
      "passenger_name": null,
      "departure_time": "09:25",
      "arrival_time": "03:45",
      "_id": "69d7da95ca72c980c3523a7a"
    },
    {
      "from": "H Nizamuddin",
      "to": "Nagpur",
      "journey_date": "2024-05-28",
      "mode_of_transport": "train",
      "pnr": null,
      "seat_no": null,
      "operator": "Indian Railways",
      "vehicle_number": "12652 (Smpark Krnt Exp)",
      "passenger_name": null,
      "departure_time": "05:20",
      "arrival_time": "22:20",
      "_id": "69d7da95ca72c980c3523a7b"
    }
  ],
  "updatedAt": "2026-04-09T16:57:58.208Z"
}
];

export default dummyVouchers;





